import { DateStyles } from 'components/DatePickerStyled/Styles/Styles'
import Flex from 'components/Flex'
import Label from 'components/Form/Label'
import { FormItem } from 'components/UIComponents/FormStyles'
import CalendarIcon from 'components/icons/CalendarIcon'
import React from 'react'
import styled from 'styled-components'

const StyledFlex = styled(Flex)`
  width: ${props => props.width};
  position: relative;
`

const DatePicker = ({
  suffixIcon = <CalendarIcon />,
  id,
  width = '50%',
  name = 'date',
  rules,
  color = '#010E30',
  placeholder = 'DD/MM/YYYY',
  dateFormat = 'DD/MM/YYYY',
  label,
  help,
  mode,
  error,
  ...props
}) => {
  return (
    <StyledFlex column width={width} id="datePicker">
      <Label>{label}</Label>
      <FormItem name={name} rules={rules} help={help} width={'100%'}>
        <DateStyles
          suffixIcon={suffixIcon}
          id={id}
          width={'100%'}
          color={color}
          opacity="1"
          placeholder={placeholder}
          format={dateFormat}
          mode={mode}
          getPopupContainer={() => document.getElementById(`datePicker`)}
          {...props}
        />
      </FormItem>
      <span style={{
        color: 'red',
        fontSize: '12px',
        minHeight: '18px',
        marginTop: 4
      }}>
        {error || ''}
      </span>
    </StyledFlex>
  )
}

export default DatePicker
